import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Briefcase20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.09867 3.75L6.72754 1.30669C6.95938 0.958937 7.34966 0.750061 7.76761 0.750061H12.2324C12.6504 0.750061 13.0407 0.958937 13.2725 1.30669L14.9014 3.75H18.5C19.1904 3.75 19.75 4.30964 19.75 5V17C19.75 17.6904 19.1904 18.25 18.5 18.25H1.5C0.809645 18.25 0.25 17.6904 0.25 17V5C0.25 4.30965 0.809643 3.75 1.5 3.75H5.09867ZM6.90144 3.75L7.9014 2.25006H12.0986L13.0986 3.75H6.90144ZM9.25 10V10.7382C6.6335 10.6582 4.0366 10.1637 1.75 9.04111V5.25H18.25V9.04183C15.9642 10.1666 13.3668 10.6613 10.75 10.739V10H9.25ZM18.25 10.6945C15.8829 11.7251 13.2931 12.1684 10.75 12.2396V15H9.25V12.2389C6.70714 12.1655 4.11767 11.7221 1.75 10.6932V16.75H18.25V10.6945Z'
      fill='currentColor'
    />
  </Svg>
);

Briefcase20.displayName = 'Briefcase20';
export default Briefcase20;
